import React from 'react'

export const SwapArrows = ({ fill }) => (

  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox="0 0 40 35">
    <g>
	<g>
		<g>
			<g>
				<g>
					<path className="st0" d="M14.0602,18.6808c-0.3491,0-0.6321-0.283-0.6321-0.6318V9.1162h-3.2703
						c-0.2555,0-0.4862-0.1541-0.5839-0.3901c-0.0978-0.2363-0.0437-0.5081,0.137-0.6889l6.9373-6.9373
						c0.2469-0.2469,0.6469-0.2469,0.8938,0l6.9373,6.9373c0.1807,0.1807,0.2351,0.4526,0.1373,0.6889
						c-0.0983,0.236-0.3284,0.3901-0.5842,0.3901h-3.2705v8.6777c0,0.3491-0.2827,0.6321-0.6318,0.6321
						c-0.3491,0-0.6321-0.283-0.6321-0.6321V8.4841c0-0.3491,0.283-0.6321,0.6321-0.6321h2.3765l-5.4114-5.4114L11.6837,7.852
						h2.3765c0.3491,0,0.6321,0.283,0.6321,0.6321v9.5648C14.6922,18.3978,14.4093,18.6808,14.0602,18.6808z"/>
				</g>
				<g>
					<path className="st0" d="M14.0602,23.2441c-0.3491,0-0.6321-0.283-0.6321-0.6321v-1.996c0-0.3491,0.283-0.6321,0.6321-0.6321
						c0.3491,0,0.6321,0.283,0.6321,0.6321v1.996C14.6922,22.9611,14.4093,23.2441,14.0602,23.2441z"/>
				</g>
			</g>
		</g>
	</g>
	<g>
		<g>
			<g>
				<g>
					<path className="st0" d="M23.1648,34.6733L23.1648,34.6733c-0.1674,0-0.3284-0.0667-0.4469-0.1852l-6.9373-6.9375
						c-0.1807-0.1807-0.2348-0.4528-0.137-0.6889c0.0978-0.236,0.3284-0.3901,0.5839-0.3901h3.2703l0.0002-8.6777
						c0-0.3491,0.283-0.6321,0.6321-0.6321l0,0c0.3491,0,0.6323,0.283,0.6323,0.6321l-0.0005,9.3098
						c0,0.3491-0.283,0.6321-0.6321,0.6321h-2.3765l5.4114,5.4117l5.4117-5.4117h-2.3767c-0.3491,0-0.6321-0.283-0.6321-0.6321
						v-9.5646c0-0.3491,0.283-0.6321,0.6321-0.6321c0.3491,0,0.6321,0.283,0.6321,0.6321v8.9325h3.2705
						c0.2558,0,0.4859,0.1541,0.5842,0.3901c0.0978,0.236,0.0435,0.5081-0.1373,0.6889l-6.9375,6.9375
						C23.4932,34.6066,23.3322,34.6733,23.1648,34.6733z"/>
				</g>
				<g>
					<path className="st0" d="M26.1997,15.6043c-0.3491,0-0.6321-0.283-0.6321-0.6321V12.976c0-0.3491,0.283-0.6321,0.6321-0.6321
						c0.3491,0,0.6321,0.283,0.6321,0.6321v1.9962C26.8318,15.3214,26.5488,15.6043,26.1997,15.6043z"/>
				</g>
			</g>
		</g>
	</g>
</g>
  </svg>
)
